<template>
  <OtherProfileBody/>
</template>

<script>
// @ is an alias to /src
import OtherProfileBody from '@/components/OtherProfileBody.vue'

export default {
  name: 'OtherProfileView',
  components: {
    OtherProfileBody
  }
}
</script>
